import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ACTIONS from '../actionTypes';
import { PaymentMeanDetailsModalV5 } from '../../components/PaymentMeanDetailsModal/PaymentMeanDetailsModalV5';
const mapStateToProps = (state, ownProps) => {
    var _a;
    const data = ((_a = state.paymentMeanDetailsModal) === null || _a === void 0 ? void 0 : _a.data) || (ownProps === null || ownProps === void 0 ? void 0 : ownProps.data);
    return {
        paymentMeanDetailsModal: state.paymentMeanDetailsModal,
        data,
        router: state.router,
    };
};
const PaymentMeanDetailsModalContainerHyperNova = (props) => {
    const paymentMeanDetailsModalState = useSelector((state) => state.paymentMeanDetailsModal);
    const dispatch = useDispatch();
    const handleMultiPaymentEvent = (paymentMeanDetailsModalEvent) => {
        if (paymentMeanDetailsModalEvent.detail) {
            dispatch({ type: ACTIONS.SHOW, payload: paymentMeanDetailsModalEvent.detail });
        }
    };
    useEffect(() => {
        document.addEventListener('PAYMENT-MEAN-DETAILS-MODAL', handleMultiPaymentEvent);
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        return () => {
            document.removeEventListener('PAYMENT-MEAN-DETAILS-MODAL', handleMultiPaymentEvent);
        };
    }, []);
    return (React.createElement(React.Fragment, null, paymentMeanDetailsModalState.visible && (React.createElement(PaymentMeanDetailsModalV5, { extraClassName: '_hy', isEligibleToKlarna: paymentMeanDetailsModalState.isEligibleToKlarna, price: paymentMeanDetailsModalState.price, paymentMethods: paymentMeanDetailsModalState.paymentMethods, isEligibleToFloa10x: paymentMeanDetailsModalState.isEligibleToFloa10x, isEligibleToPaypal4x: paymentMeanDetailsModalState.isEligibleToPaypal4x }))));
};
const connector = connect(mapStateToProps);
export const ConnectedPaymentMeanDetailsModal = connect(mapStateToProps)(PaymentMeanDetailsModalContainerHyperNova);
export const PaymentMeanDetailsModalContainer = ConnectedPaymentMeanDetailsModal;
